import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/xmjrRoHvrxanNkG8pTnxnx/ChatGPT-Image-20-jun-2026_-22_07_30.webp';
export function Hero() {
  return <section className="pt-7 pb-5 px-4 sm:px-6 bg-brand-beige text-center border-b-2 border-brand-brown/20" data-id="element-83">
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-green/10 border border-brand-green/30 text-brand-green font-bold text-xs sm:text-sm mb-3 shadow-sm" data-id="element-84">
        <span data-id="element-85">🐾</span>
        <span className="tracking-wide uppercase" data-id="element-86">DOG TRAINER PRO™</span>
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-5xl font-heading font-black text-brand-green leading-tight mb-3" data-id="element-87">
        The Complete Training System for Dog Trainers &amp; Reactive Dog Owners
      </h1>

      <p className="text-base sm:text-lg text-brand-ink/80 font-medium leading-snug mb-4 max-w-2xl mx-auto" data-id="element-88">
        Save hours of planning, deliver better results, and train with
        confidence — without starting from scratch.
      </p>

      <a href="#pricing" className="block cursor-pointer mb-4" data-id="element-89">
        <img src={PRODUCT_IMG} alt="Dog Trainer Pro 6-in-1 Complete Box Set" className="w-full h-auto object-contain max-w-[320px] sm:max-w-md mx-auto hover:scale-[1.02] transition-transform duration-300 drop-shadow-xl rounded-lg" data-id="element-90" />
      </a>

      <div className="mb-3 max-w-md mx-auto" data-id="element-91">
        <CTAButton data-id="element-92">🚀 YES, I WANT MY SYSTEM NOW</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-1.5 sm:gap-6 text-xs sm:text-sm text-brand-green font-bold" data-id="element-93">
        <div className="flex items-center gap-1.5" data-id="element-94">
          <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-95" />
          <span data-id="element-96">4.9/5 — Verified Professional Reviews</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-97">
          <Shield className="w-4 h-4 text-brand-brown" data-id="element-98" />
          <span data-id="element-99">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}